import { InviteFormFields } from './types';

export const EMPLOYER_INITIAL_VALUES = {
  email: '',
  shouldCreateBillingRules: false,
};

export const INITIAL_VALUES = {
  [InviteFormFields.employers]: [EMPLOYER_INITIAL_VALUES],
};
